import React from 'react'
import { motion } from 'framer-motion'
import { Pagination, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { TypographyTitle } from 'src/components/common/Typography/typography'
import {
    ContentTestimonials,
    ContentTestimonialsSwiper,
    ContentTestimonialsSwiperSlide,
} from './styles'
import { OverSection } from 'src/pages/Home/styles'
import { MapTestimonials } from './mapTestimonials'
import { TestimonialsLabels } from 'src/constants'
import {
    container,
    item,
    scaleVariantTitle,
} from 'src/theme/animations/swipeIn'
import { useAnimation } from 'src/hook'
import { useTranslations } from 'src/provider/LocaleProvider'

export const Testimonials = () => {
    const t = useTranslations()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    const { TestimonialsContent } = TestimonialsLabels()

    return (
        <OverSection
            paddingTop={['medium', 'medium', 'titlle', 'titlle']}
            paddingBottom={['medium', 'medium', 'titlle', 'titlle']}
            ref={ref}
        >
            <TypographyTitle
                variant={'h1'}
                fontSize={['xxxlarge', 'xxxlarge', 'xxxlarge', 'titlle']}
                fontWeight={600}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('testimonials.title')}
            </TypographyTitle>
            <ContentTestimonials
                marginTop={['xxxmedium', 'xxxmedium', 'xlarge', 'xsixty']}
                initial="hidden"
                animate={control}
                variants={container}
            >
                {TestimonialsContent.map((Data) => (
                    <motion.div
                        initial="hidden"
                        animate={control}
                        variants={item}
                        key={Data.id}
                    >
                        <MapTestimonials {...Data} />
                    </motion.div>
                ))}
            </ContentTestimonials>
            <ContentTestimonialsSwiper
                centeredSlides={true}
                loop={true}
                spaceBetween={0.1}
                pagination={{
                    clickable: true,
                }}
                breakpoints={{
                    425: {
                        slidesPerView: 1,
                        centeredSlides: true,
                    },
                    768: {
                        slidesPerView: 2,
                        centeredSlides: false,
                    },
                    1024: {
                        slidesPerView: 2,
                        centeredSlides: false,
                    },
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                {TestimonialsContent.map((Data) => (
                    <ContentTestimonialsSwiperSlide key={Data.id}>
                        <MapTestimonials {...Data} />
                    </ContentTestimonialsSwiperSlide>
                ))}
            </ContentTestimonialsSwiper>
        </OverSection>
    )
}
